import { Search } from '@karma/components';
import styled from 'styled-components';

export const StyledSearch = styled(Search)`
  margin-bottom: 32px;
  height: 50px;
`;
